
define('ldsh!modules/start/products/automation/status/template', ['lodash'], function(_) {return function(obj) {
obj || (obj = {});
var __t, __p = '', __e = _.escape, __j = Array.prototype.join;
function print() { __p += __j.call(arguments, '') }
with (obj) {

 if (productDetails.isRequest) { ;
__p += '\n    <div class="text-center">\n        <i class="ri-loader-4-fill fa-spin product-spinner"></i>\n    </div>\n';
 } else { ;
__p += '\n    <div class="row row-same-height"></div>\n';
 } ;
__p += '\n';

}
return __p
};});

